<app-device-dashboard
  (onUpdate)="onDeviceDashboardUpdated($event)">
</app-device-dashboard>

<div class="action-header_container action-header_container--single">
  @if (!authService.isClinicalTrialReadOnlyNoPii) {
    <app-review-patients>
    </app-review-patients>
  }
</div>

<app-list-header
  name="patient"
  [canCreate]="!authService.isClinicalTrialReadOnlyNoPii"
  (onCreate)="create()"
  (onSearch)="search($event)">
</app-list-header>

<app-item-list
  [columns]="columns"
  [actions]="actions"
  [orangeMarker]="orangeMarker"
  [items$]="patients$"
  [pageSize]="currentPageSize"
  (onItemClick)="view($event)"
  (onChangePage)="changePage($event.pageIndex, $event.pageSize)">
</app-item-list>

@if (isLoading) {
  <app-loader [transparent]="true"></app-loader>
}